var rand = function rand2() {
  return `${Math.round(Math.random() * 1e8)}`;
};
export {
  rand
};
//# sourceMappingURL=rand.js.map
